import { db, type LocalMomentImages } from './db'

export const storeMomentImagesPayload = async (payload: LocalMomentImages) => {
  await db.momentImages.add(payload)
}

export const storeMomentImagesPayloads = (payloads: LocalMomentImages[]) => {
  db.transaction('rw!', db.momentImages, (tx) => {
    tx.momentImages.bulkAdd(payloads)
  })
}

export const getMomentImagesPayload = async () => {
  const payload = await db.momentImages.toArray()
  return payload
}

export const getMomentImagesPayloadByMomentId = async (momentId: string) => {
  const payload = await db.momentImages
    .where('momentId')
    .equals(momentId)
    .sortBy('order')
  return payload
}

export const deleteMomentImagesPayload = async () => {
  await db.momentImages.clear()
}

export const deleteMomentImagesPayloadByMomentId = async (momentId: string) => {
  await db.momentImages.where('momentId').equals(momentId).delete()
}

export const deleteMomentImagesPayloadById = async (id: number) => {
  await db.momentImages.delete(id)
}
